export const visit = "Visit"
export const cleaning = "Cleaning"
export const signIn = "Sign In"
export const signUp = "Sign Up"
export const next = "Next"
export const enterPassword = "Enter Password"
export const forgotPassword  = "Forgot password ?"
export const emailEmpty = "Email cannot be empty"
export const pwdEmpty = "Password cannot be empty"
export const InvalidUserID = "Email not registered"
export const InvalidPwd = "Invalid Password"
export const InvalidDomain = "Invalid Domain"
export const UserNotActive = "Your account is not active. To activate your account please contact with Visit Cleaning Admin team."
export const Here = "here"
export const LoginAgain = "to login again."
export const Click = "Please click "
export const Support = "For any support please contact"
export const SupportMail = "Coop Admin team."